<template>
    <AppLayout>
        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <fakturyMenu></fakturyMenu>
                <div class="widget-heading">
                    <div class="row">
                        <div class="col-12 d-inline-flex align-items-center">
                            <h4 class="me-3 my-0">Opisy faktur</h4>
                            <button @click="openModal" class="btn btn-primary"><i class="bi bi-plus-circle me-2"></i>Dodaj nową fakturę
                            </button>
                        </div>
                    </div>
                </div>
                <div class="widget-content">
                    <div class="row mb-3">
                        <div class="col-md-4">
                            <input
                                v-model="search"
                                type="text"
                                class="form-control"
                                placeholder="Szukaj (numer, dostawca, opis...)" />
                        </div>
                    </div>

                    <div class="custom-table">
                        <div class="table-responsive">
                            <table class="table table-hover table-bordered w-100">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Numer faktury</th>
                                        <th>Data wystawienia</th>
                                        <th>Dostawca</th>
                                        <th>Opis</th>
                                        <th>Opcje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(faktura, index) in filteredFaktury" :key="faktura.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>
                                            {{ faktura.numer }}
                                            <div class="mt-1">
                                                <span
                                                    class="badge"
                                                    :class="{
							'bg-success': faktura.opis && faktura.opis.length >= 3,
							'bg-danger': !faktura.opis || faktura.opis.length < 3
						  }">
                                                    {{ faktura.opis && faktura.opis.length >= 3 ? 'Opis dodany' : 'Brak opisu' }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>{{ formatDate(faktura.data) }}</td>
                                        <td>{{ faktura.dostawca }}</td>
                                        <td :title="faktura.opis">{{ shortOpis(faktura.opis) }}</td>
                                        <td>
                                            <button @click="editFaktura(faktura)" class="btn btn-sm btn-outline-info me-2 mb-2">
                                                <i class="bi bi-pencil me-2"></i>Otwórz
                                            </button>
                                            <button @click="usun(faktura.id)" class="btn btn-sm btn-danger mb-2">
                                                <i class="bi bi-trash me-2"></i>Usuń
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Dane faktury do opisania</h5>
                                    <button type="button" class="btn-close" @click="closeModal"></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="form-label" for="numer-new">Numer faktury:</label>
                                            <input id="numer-new" v-model="newFaktura.numer" class="form-control" />
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label" for="data-new">Data wystawienia:</label>
                                            <input id="data-new" type="date" v-model="newFaktura.data" class="form-control" />
                                        </div>
                                        <div class="col-md-12">
                                            <label class="form-label" for="dostawca-new">Dostawca:</label>
                                            <textarea id="dostawca-new" v-model="newFaktura.dostawca" class="form-control" rows="3"></textarea>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="form-label" for="opis-new">Opis:</label>
                                            <textarea id="opis-new" v-model="newFaktura.opis" class="form-control" rows="3"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                                    <button class="btn btn-primary" @click="saveNew">Zapisz</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Edycja danych faktury</h5>
                                    <button type="button" class="btn-close" @click="closeEditModal"></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="form-label" for="numer">Numer faktury:</label>
                                            <input id="numer" v-model="editedFaktura.numer" class="form-control" />
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label" for="data">Data wystawienia:</label>
                                            <input id="data" type="date" v-model="editedFaktura.data" class="form-control" />
                                        </div>
                                        <div class="col-md-12">
                                            <label class="form-label" for="dostawca">Dostawca:</label>
                                            <textarea id="dostawca" v-model="editedFaktura.dostawca" class="form-control" rows="3"></textarea>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="form-label" for="opis">Opis:</label>
                                            <textarea id="opis" v-model="editedFaktura.opis" class="form-control" rows="10"></textarea>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <ul class="list-group ps-3 me-3 mt-3 mb-3">
                                            <li
                                                class="list-group-item d-flex align-items-center justify-content-between flex-wrap fw-bold bg-light"
                                                v-if="localFiles.length > 0">
                                                <div class="col-12 col-sm-6 col-md-5 text-truncate">Nazwa pliku</div>
                                                <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">Opcje</div>
                                            </li>
                                            <li v-if="isLoadingFiles" class="list-group-item border-0">
                                                <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                                                    Ładowanie...
                                                </div>
                                            </li>
                                            <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else
                                                v-for="file in localFiles" :key="file.id">
                                                <div class="col-12 col-sm-6 col-md-5 text-truncate" :title="file.name">{{ file.name }}</div>
                                                <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                                                    <div class="d-flex justify-content-end flex-wrap gap-1">
                                                        <a
                                                            class="btn btn-sm btn-outline-info"
                                                            :href="route('kadry.opisy_faktur.files.download', file.id)">
                                                            Pobierz
                                                        </a>

                                                        <button class="btn btn-sm btn-outline-danger" style="width:80px;" @click="deleteFile(file)"
                                                            type="button"><i class="bi bi-trash me-1"></i>Usuń</button>
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="list-group-item" v-if="localFiles.length <= 0 && !isLoadingFiles">
                                                <i>Brak plików</i>
                                            </li>
                                        </ul>
                                    </div>
                                    <form @submit.prevent="submitForm">
                                        <div class="row gap-3">
                                            <div class="col-12">
                                                <label for="attachments">Dodaj pliki:</label>
                                                <div v-if="isLoading" class="mt-3">
                                                    <div class="progress" style="height: 8px;">
                                                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                                                            :style="{ width: uploadProgress + '%' }"></div>
                                                    </div>
                                                    <small class="text-muted">{{ uploadProgress }}%</small>
                                                </div>
                                                <input type="file" id="attachments" multiple @change="handleFileUpload"
                                                    class="form-control form-control-sm" ref="fileInput" />
                                                <div v-if="form?.attachments?.length">
                                                    <p class="mt-2">Załączone pliki:</p>
                                                    <ul class="list-group">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                                                            v-for="(file, index) in form.attachments" :key="index">
                                                            <span class="text-truncate" :title="file.name">{{ file.name }}</span>
                                                            <button type="button" class="btn btn-sm btn-danger ms-2 mt-1 mt-sm-0"
                                                                @click="removeFile(index)">Usuń</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div v-if="form.attachments.length">
                                                    <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading">{{ isLoading ?
							'Wysyłanie...' :
							'Dodaj pliki' }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>


                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="closeEditModal">Anuluj</button>
                                    <button class="btn btn-primary" @click="updateFaktura(editedFaktura)">Zapisz</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from "@/Layouts/App.vue";
    import fakturyMenu from "@/Pages/Kadry/parts/fakturyMenu.vue";

    export default {
        components: {
            AppLayout,
            fakturyMenu
        },
        props: {
            listaFaktur: Array
        },
        data() {
            return {
                form: {
                    attachments: []
                },
                localFiles: [],
                isLoading: false,
                isLoadingFiles: false,
                uploadProgress: 0,
                search: '',
                newFaktura: this.getEmptyForm(),
                editedFaktura: {},
                isModalOpen: false,
                isEditModalOpen: false,
                listFakturLocal: [...this.listaFaktur],
            };
        },
        watch: {
            listaFaktur: {
                handler(nowe) {
                    this.listFakturLocal = [...nowe]; // aktualizacja jeśli props się zmieni
                },
                immediate: true
            }
        },
        computed: {
            filteredFaktury() {
                let list = this.listFakturLocal;

                // 1️⃣ filtr wyszukiwania
                if (this.search) {
                    const s = this.search.toLowerCase();
                    list = list.filter(f => {
                        return (
                            (f.numer && f.numer.toLowerCase().includes(s)) ||
                            (f.dostawca && f.dostawca.toLowerCase().includes(s)) ||
                            (f.opis && f.opis.toLowerCase().includes(s))
                        );
                    });
                }

                // 2️⃣ sortowanie: brak opisu na górze, potem według daty malejąco
                list.sort((a, b) => {
                    const aNoOpis = !a.opis || a.opis.length < 3;
                    const bNoOpis = !b.opis || b.opis.length < 3;

                    if (aNoOpis && !bNoOpis) return -1; // brak opisu na górze
                    if (!aNoOpis && bNoOpis) return 1;

                    // potem sortowanie po dacie malejąco (najnowsze na górze)
                    const dateA = a.data ? new Date(a.data) : new Date(0);
                    const dateB = b.data ? new Date(b.data) : new Date(0);

                    return dateB - dateA;
                });

                return list;
            }
        },

        methods: {
            shortOpis(opis) {
                if (!opis) return '';

                return opis.length > 30 ?
                    opis.substring(0, 30) + '...' :
                    opis;
            },

            async deleteFile(file) {
                Toast.fire({
                    toast: false,
                    icon: 'warning',
                    title: 'Usuwanie pliku',
                    html: 'Czy na pewno chcesz usunąć ten plik?',
                    showDenyButton: true,
                    showConfirmButton: true,
                    confirmButtonText: 'Tak',
                    denyButtonText: 'Nie',
                    timer: false,
                    position: 'center',
                }).then(async (result) => {
                    if (!result.isConfirmed) return;

                    try {
                        await axios.delete(
                            route('kadry.opisy_faktur.files.destroy', file.id)
                        );

                        Toast.fire({
                            icon: 'success',
                            title: 'Usunięto plik',
                            text: 'Plik został pomyślnie usunięty.',
                            timer: 2000,
                        });

                        await this.getAttachments();

                    } catch (error) {
                        console.error('Błąd usuwania pliku:', error);

                        Toast.fire({
                            icon: 'error',
                            title: 'Błąd',
                            text: 'Nie udało się usunąć pliku.',
                        });
                    }
                });
            },


            async getAttachments() {
                if (!this.editedFaktura?.id) return;

                this.isLoadingFiles = true;
                try {
                    const res = await axios.get(
                        route('kadry.opisy_faktur.files.index', this.editedFaktura.id)
                    );
                    this.localFiles = res.data.files;
                } finally {
                    this.isLoadingFiles = false;
                }
            },


            handleFileUpload(event) {
                this.uploadError = null;
                const files = Array.from(event.target.files);

                const maxSize = 100 * 1024 * 1024; // 100 MB
                const validFiles = [];

                for (let file of files) {
                    if (file.size > maxSize) {
                        this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
                    } else if (file.size === 0) {
                        this.uploadError = `Plik "${file.name}" jest pusty.`;
                    } else {
                        validFiles.push(file);
                    }
                }

                if (validFiles.length > 0) {
                    this.form.attachments.push(...validFiles);
                }

                this.$refs.fileInput.value = "";
            },

            removeFile(index) {
                this.form.attachments.splice(index, 1);
            },


            async submitForm() {
                const formData = new FormData();
                this.form.attachments.forEach(f => {
                    formData.append('attachments[]', f);
                });

                this.isLoading = true;

                await axios.post(
                    route('kadry.opisy_faktur.files.store', this.editedFaktura.id),
                    formData, {
                        onUploadProgress: e => {
                            this.uploadProgress = Math.round((e.loaded * 100) / e.total);
                        }
                    }
                );

                this.form.attachments = [];
                this.uploadProgress = 0;
                this.isLoading = false;

                this.getAttachments();
            },

            formatDate(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // miesiące 0-11
                const year = date.getFullYear();
                return `${day}.${month}.${year}`;
            },

            async openModal() {
                this.isModalOpen = true;
            },

            closeModal() {
                this.isModalOpen = false;
                this.newFaktura = this.getEmptyForm();
            },

            closeEditModal() {
                this.isEditModalOpen = false;
            },

            getEmptyForm() {
                return {
                    id: null,
                    numer: '',
                    data: '',
                    dostawca: '',
                    opis: '',
                };
            },

            editFaktura(faktura) {
                this.isEditModalOpen = true;
                this.editedFaktura = {
                    ...faktura
                };
                this.getAttachments();
                this.form.attachments = [];
            },

            updateFaktura(editfaktura) {
                this.$inertia.put(route('kadry.opisy_faktur.update', editfaktura.id), editfaktura, {
                    onSuccess: () => {
                        const idx = this.listFakturLocal.findIndex(w => w.id === editfaktura.id);
                        if (idx !== -1) {
                            this.listFakturLocal[idx] = {
                                ...editfaktura
                            };
                        }
                        this.isEditModalOpen = false;
                    }
                });
            },

            saveNew() {
                this.$inertia.post(route('kadry.opisy_faktur.dodaj'), this.newFaktura, {
                    onSuccess: (page) => {
                        const nowy = page.props.flash?.newFaktura ?? null;
                        if (nowy) {
                            this.listFakturLocal.push(nowy);
                        }
                        this.newFaktura = this.getEmptyForm();
                        this.isModalOpen = false;
                    }
                });
            },

            usun(id) {
                Toast.fire({
                    toast: false,
                    icon: 'warning',
                    title: 'Usuwanie faktury z listy faktur do opisu',
                    html: 'Czy na pewno chcesz usunąć wybraną fakturę z listy?',
                    showDenyButton: true,
                    showConfirmButton: true,
                    confirmButtonText: 'Tak',
                    denyButtonText: 'Nie',
                    timer: false,
                    position: 'center'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$inertia.delete(route('kadry.opisy_faktur.usun', id), {
                            onSuccess: () => {
                                this.listFakturLocal = this.listFakturLocal.filter(w => w.id !== id);
                            }
                        });
                    }
                });
            }
        }
    };
</script>
<style scoped>
</style>